export const PACKAGE_TYPES = [
    { id: 'parcel_bag', name: 'parcel_bag' },
    { id: 'jiffy_envelope', name: 'jiffy_envelope' },
    { id: 'cubbo_box', name: 'cubbo_box' },
    { id: 'packageless', name: 'packageless' },
    { id: 'customer_box', name: 'customer_box' }
];
